import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import NewRouteForm from "./NewRouteForm";
import { AmeaCategorySingularName, HandleBinIcon } from "../helpers";
import * as Icon from "../smartiscity/Icons";
import { useAuth } from "../../../hooks/UserAuthProvider";
import SvgRecycleBinFull from "../../../assets/icons/RecycleBinFull";
import SvgRecycleBinEmpty from "../../../assets/icons/RecycleBinEmpty";
import SvgRecycleBinLow from "../../../assets/icons/RecycleBinLow";
import SvgRecycleBinNA from "../../../assets/icons/RecycleBinNA";
import { useTranslation } from "react-i18next";

const DataList = ({
  data,
  showNewRouteForm,
  mapData,
  rightSideBox,
  categoryId,
  selectedCategory,
  selectedItem,
  setSelectedRoute,
}) => {
  const { userData, isAuthenticated } = useAuth();

  const { t } = useTranslation();

  const listItemIcon = (icon) => (
    <i
      className={`im ${icon}`}
      style={{ fontSize: "30px", float: "left", color: "inherit" }}
    ></i>
  );

  const renderMeteoIcons = useCallback((items, key) => {
    return items?.map((item, id) => (
      <img
        key={`${key}_icon_${id}`}
        src={`https://volos.smartiscity.gr/gallery/vars/Small/${item.sensorvar_icon}`}
        alt={item.sensorvar_description}
      />
    ));
  }, []);

  const renderDate = (date) => {
    const newD = new Date(date);
    return `${newD.getDate() < 10 ? `0${newD.getDate()}` : newD.getDate()}/${
      newD.getMonth() + 1
    }/${newD.getFullYear()} | ${
      newD.getHours() < 10 ? `0${newD.getHours()}` : newD.getHours()
    }:${newD.getMinutes() < 10 ? `0${newD.getMinutes()}` : newD.getMinutes()}`;
  };

  const handleItemClick = useCallback(
    (item) => {
      const rightSideMap = {
        1: true,
        4: false,
        5: true,
        7: false,
        8: true,
        9: true,
        10: true,
        12: true,
        24: true,
        30: false,
        31: false,
        122: selectedCategory === "infra" ? false : !showNewRouteForm.get,
      };

      if (rightSideMap[categoryId]) {
        if (!rightSideBox.isVisible) {
          rightSideBox.setIsVisible(true);
        }
      }
      selectedItem.setItem(item);
      if (selectedCategory === "routes") {
        setSelectedRoute(item);
      }
    },
    [selectedCategory, showNewRouteForm.get, categoryId]
  );

  const renderDataItem = useCallback(
    (item, index) => {
      const itemContent = {
        1: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Globe")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>
                {t("environmental.station")}
                <br />
                {t(`areaNames.${item.ref_id}`)}
              </p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
              <div>{renderMeteoIcons(item.details, item.mysensor_name)}</div>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        4: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Wifi")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              {item.metrics?.length > 0 && (
                <p style={{ fontSize: "14px" }}>
                  {item.metrics[0]?.content}: {item.metrics[0]?.value}
                </p>
              )}
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        5: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Cloud-Sun")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
              <div>{renderMeteoIcons(item.details, item.mysensor_name)}</div>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        7: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Map-Marker")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        8: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Truck")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.category_name}</p>
              <p style={{ fontSize: "14px" }}>Πινακίδα: {item.name}</p>
              <p style={{ fontSize: "14px" }}>Ταχύτητα: {item.speed} km/h</p>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),

        9: () => (
          <RenderDataItemContainer>
            <div
              style={{
                width: "50px",
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {HandleBinIcon(parseInt(item.value))}
            </div>
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.address}</p>
              <p style={{ fontSize: "14px" }}>
                Πληρότητα Κάδου:{" "}
                <span style={{ fontWeight: "600" }}>{item.value}%</span>
              </p>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        10: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Gaugage")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.location}</p>
              <p style={{ fontSize: "14px" }}>
                Τελευταία ενημέρωση: {renderDate(item.date)}
              </p>
              {/* <p style={{ fontSize: "14px" }}>Ταχύτητα: {item.speed} km/h</p> */}
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),

        12: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-On-Off-3")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item?.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>
                Μέτρηση:{" "}
                {`${item.details[0]?.measurement} ${item.details[0]?.sensorvar_unit}`}
              </p>
              <div>
                <img
                  src={`https://preveza.smartiscity.gr/gallery/vars/Small/${item.details[0]?.sensorvar_icon}`}
                  alt={item.details[0]?.sensorvar_icon}
                />
              </div>
              {/* <p style={{ fontSize: "14px" }}>Ταχύτητα: {item.speed} km/h</p> */}
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        24: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Car-2")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.LabelOnStreet}</p>
              <p style={{ fontSize: "14px" }}>Τύπος: {item.Type}</p>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        30: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Map-Marker")}
            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        31: () => (
          <RenderDataItemContainer>
            {listItemIcon("im-icon-Monitor-Vertical")}

            <RenderDataItemContent>
              <p style={{ fontWeight: "500" }}>{item.mysensor_name}</p>
              <p style={{ fontSize: "14px" }}>{item.sensor_address}</p>
              {item?.metrics && (
                <p style={{ fontSize: "14px" }}>
                  <span style={{ fontWeight: "500", marginRight: "5px" }}>
                    {item?.metrics[0]?.content}:
                  </span>
                  {item?.metrics[0]?.value}
                </p>
              )}
            </RenderDataItemContent>
          </RenderDataItemContainer>
        ),
        122: () => (
          <>
            <img
              src={
                item?.type === "user"
                  ? Icon.defaultRoutesUser
                  : Icon.defaultRoutes
              }
              alt="Default Route"
            />
            {selectedCategory === "infra" ? (
              <div>
                <p>{`${AmeaCategorySingularName(item.category)} (${
                  item.title
                })`}</p>
                <p>{`${item.type}ς Χρήσης`}</p>
              </div>
            ) : (
              <div>
                <p>{item.title}</p>
                <p style={{ fontSize: "14px" }}>{item.category}</p>
                <p style={{ fontSize: "14px" }}>Απόσταση: {item.distance} m</p>
              </div>
            )}
          </>
        ),
      };

      return (
        <LeftSideItemContainer
        role="button"
        tabIndex={0}
          key={`${categoryId}_item_${index}_${
            item.type === "user" ? "_user" : "_route"
          }`}
          $selectedItemId={
            selectedItem.getItem?.id ??
            selectedItem.getItem?.mysensor_id ??
            selectedItem.getItem
          }
          $itemId={item.id ?? item.mysensor_id ?? item}
          onClick={() => handleItemClick(item)}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleItemClick(item)}
          aria-label={`Select ${item.name ?? item.mysensor_id}`}
        >
          {itemContent[categoryId]?.() ?? <p>Item {index}</p>}
        </LeftSideItemContainer>
      );
    },
    [
      categoryId,
      selectedCategory,
      handleItemClick,
      renderMeteoIcons,
      selectedItem,
    ]
  );

  const renderDataItems = () => {
    const userItems =
      isAuthenticated && categoryId === "122" && selectedCategory === "routes"
        ? userData.routes.map(renderDataItem)
        : [];
    const dataItems = data.map(renderDataItem);
    return [...userItems, ...dataItems];
    // return dataItems;
  };

  const renderData = useCallback(() => {
    return data?.length > 0 ? renderDataItems(data.map(renderDataItem)) : [];
  }, [data, renderDataItem]);

  return (
    <LeftSideData>
      {showNewRouteForm.get ? (
        <NewRouteForm showNewRouteForm={showNewRouteForm} mapData={mapData} />
      ) : (
        renderData()
      )}
    </LeftSideData>
  );
};

export default DataList;

const LeftSideData = styled.div`
  width: 100%;
`;

const RenderDataItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const RenderDataItemContent = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const LeftSideItemContainer = styled.div`
  width: 100%;
  background-color: ${({ $selectedItemId, $itemId }) => {
    return $selectedItemId != null &&
      $itemId != null &&
      $selectedItemId === $itemId
      ? "rgba(0, 0, 0, 0.1)"
      : "unset";
  }};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  padding: 20px 30px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
`;
